import React from "react";
import styles from "./DataTable.module.css";
import { Table } from "antd";
import styled from "@emotion/styled";

const CustomDataTable = styled(Table)`
  && .ant-table-thead .ant-table-cell {
    background-color: transparent;
  }

  && .ant-table-thead th {
    color: #909090;
    font-size: 13px !important;
  }

  && .ant-table table {
    font-size: 14px;
  }
`;

const DataTable = ({ columns, data, scroll }) => {
  return (
    <CustomDataTable
      columns={columns}
      dataSource={data}
      className={styles.table_wrap}
      pagination={false}
      scroll={scroll}
    />
  );
};

export default DataTable;
